import { useState } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import PartnershipLevels from './components/PartnershipLevels';
import ProductPortfolio from './components/ProductPortfolio';
import Benefits from './components/Benefits';
import CoreStrategies from './components/CoreStrategies';
import QRSection from './components/QRSection';
import RegistrationForm from './components/RegistrationForm';
import Footer from './components/Footer';
import RegistrationModal from './components/RegistrationModal';

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'agency' | 'strategic'>('agency');

  const openModal = (type: 'agency' | 'strategic') => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero onRegister={() => openModal('agency')} />
      <Introduction />
      <PartnershipLevels onRegister={openModal} />
      <ProductPortfolio />
      <Benefits />
      <CoreStrategies />
      <QRSection />
      <RegistrationForm />
      <Footer />
      <RegistrationModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        type={modalType}
      />
    </div>
  );
}